import React from 'react';
import LogoMark from '../layout/LogoMark';
import { useTranslation } from '../../utils/i18n';

export default function UnlockScreen({
  unlockPassword,
  unlockError,
  onPasswordChange,
  onSubmit,
  onLogout
}) {
  const { t } = useTranslation();

  return (
    <div className="auth-wrapper">
      <div className="auth-card glass-panel unlock-card">
        <div className="auth-header">
          <LogoMark compact />
          <p>{t('unlock_title')}</p>
        </div>
        <p className="auth-copy">
          {t('unlock_desc')}
        </p>
        <form onSubmit={onSubmit}>
          <input
            type="text"
            name="username"
            autoComplete="username"
            style={{ display: 'none' }}
            readOnly
          />
          <div className="form-group">
            <label>{t('auth_password')}</label>
            <input
              type="password"
              className="input-field"
              placeholder="••••••••••••"
              value={unlockPassword}
              onChange={event => onPasswordChange(event.target.value)}
              autoComplete="current-password"
              autoFocus
              required
            />
          </div>
          {unlockError && <p className="form-error">{unlockError}</p>}
          <button type="submit" className="btn-primary">{t('unlock_btn')}</button>
        </form>
        <button type="button" className="btn-secondary" onClick={onLogout}>
          {t('unlock_logout')}
        </button>
      </div>
    </div>
  );
}
